import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navbar.css';

export default function Navbar() {
  const { currentUser, logout } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <span className="logo-icon">🚀</span>
          README <span className="logo-highlight">Gen-Rator</span>
        </Link>
        
        <div className="navbar-menu">
          {currentUser ? (
            <>
              <Link to="/generator" className="navbar-link">Dashboard</Link>
              <div className="user-menu">
                {currentUser.photoURL && (
                  <img 
                    src={currentUser.photoURL} 
                    alt="User Profile" 
                    className="user-avatar" 
                  />
                )}
                <button onClick={handleLogout} className="btn-logout">
                  Sign Out
                </button>
              </div>
            </>
          ) : (
            <Link to="/login" className="btn-signin">
              Sign In
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}
